import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { memo } from 'react';

import Box from 'shopper/components/Box';
import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import SortSelect from 'components/SortSelect';

import { isOffersFiltersActive } from 'lib/category';
import placeholder from 'lib/placeholder';
import { noop } from 'lib/utils';

const OffersOptionsBoxActiveFilters = dynamic(() => import('./ActiveFilters'), {
  ssr: false,
});

const OffersOptionsBox = ({
  offersFilters,
  options,
  onFilterButtonClick,
  onOffersFiltersChange,
  onOffersSortChange = noop,
}) => (
  <Box className="w-full flex-col justify-end p-4 md:flex-row">
    {isOffersFiltersActive(offersFilters) && (
      <OffersOptionsBoxActiveFilters
        offersFilters={offersFilters}
        onOffersFiltersChange={onOffersFiltersChange}
      />
    )}
    <div className="flex items-center gap-2">
      <Button
        className="flex w-1/2 px-8 md:w-unset xl:hidden"
        iconLeft={<Icon name="sliders" />}
        size="size2"
        onClick={onFilterButtonClick}
      >
        {placeholder('actions.showFilters')}
      </Button>
      <SortSelect options={options} onSelectChange={onOffersSortChange} />
    </div>
  </Box>
);

OffersOptionsBox.propTypes = {
  offersFilters: PropTypes.shape({
    stores: PropTypes.arrayOf(
      PropTypes.shape({
        storeId: PropTypes.number.isRequired,
        storeName: PropTypes.string.isRequired,
      })
    ).isRequired,
    priceRange: PropTypes.shape({
      min: PropTypes.number,
      max: PropTypes.number,
    }),
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      isSelected: PropTypes.bool,
    })
  ).isRequired,
  onFilterButtonClick: PropTypes.func.isRequired,
  onOffersFiltersChange: PropTypes.func.isRequired,
  onOffersSortChange: PropTypes.func,
};

export default memo(OffersOptionsBox);
